module.exports = __webpack_public_path__ + "static/images/index_box_title.51e1041.png";